import React from 'react';

function Loader(props) {
    return (
        <div className="loader">
            <i className="fa-solid fa-spinner fa-spin-pulse"></i>
            <div>{props.text}</div>
        </div>
    );
}

Loader.defaultProps = {
    text: "Daten werden geladen..",
}

export default Loader;